import type { StateCreator } from 'zustand'

import type { Invitation, User } from '../../types/user.type'
import type { UserActionsSlice, UserFetchPatch, UserStore } from '../types'

export const createUserActionsSlice: StateCreator<UserStore, [['zustand/immer', never]], [], UserActionsSlice> = (
  set
) => ({
  setState: (updateState: UserFetchPatch) => set((state) => ({ ...state, ...updateState })),
  setCurrentUser: (user: Partial<User> | User | null) =>
    set((state) => {
      state.currentUser = user as User | null
    }),

  setInvitations: (invitations: Invitation[]) =>
    set((state) => {
      state.invitations = invitations
    }),

  removeInvitation: (invitationId: string) =>
    set((state) => {
      state.invitations = state.invitations.filter((invitation) => invitation.invitationId !== invitationId)
    }),

  setLoading: (loading: boolean) =>
    set((state) => {
      state.loading = loading
    }),

  setError: (error: string | null) =>
    set((state) => {
      state.error = error
    }),
})
